import app from '@/app';

/* @ngInject */
function JhiLanguageService($q, $translate, LANGUAGES, tmhDynamicLocale) {
	return {
		getCurrent: getCurrent,
		getAll: getAll,
		changeLanguage: changeLanguage
	};

	function getCurrent() {
		var deferred = $q.defer();
		var language = $translate.storage().get('NG_TRANSLATE_LANG_KEY');

		deferred.resolve(language);

		return deferred.promise;
	}

	function getAll() {
		var deferred = $q.defer();
		deferred.resolve(LANGUAGES);
		return deferred.promise;
	}

	function changeLanguage(languageKey) {
		$translate.use(languageKey);
		tmhDynamicLocale.set(languageKey);
	}
}

app.factory('JhiLanguageService', JhiLanguageService);
